import React from "react";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import { FiLinkedin } from "react-icons/fi";
import { FaFacebookF } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <div className="flex  justify-center items-center  mt-32  py-10 text-center border-t-[1px] border-own-border-color border-opacity-20 border-b-zinc-600">
      <div className=" relative after:absolute after:content-['Sohag']  after:tracking-widest after:text-own-gray-black after:text-[6rem]   sm:after:text-[7rem] after:opacity-50 after:left-[50%] after:-translate-x-[50%] after:-top-[50px] after:-z-10">
        <ul className="flex mb-4 justify-center">
          <motion.li
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="mx-3"
          >
            <a href="https://github.com/sohagmia360" target="_blank">
              <AiFillGithub className="text-2xl text-own-secondary" />
            </a>
          </motion.li>
          <motion.li
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="mx-3"
          >
            <a href="https://www.linkedin.com/in/sohag-zayan/" target="_blank">
              <FiLinkedin className="text-2xl text-own-secondary" />
            </a>
          </motion.li>
          <motion.li
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="mx-3"
          >
            <a href="https://twitter.com/SohagGd" target="_blank">
              <AiOutlineTwitter className="text-2xl text-own-secondary" />
            </a>
          </motion.li>
          <motion.li
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="mx-3"
          >
            <a
              href="https://www.facebook.com/sohaghossainzayan"
              target="_blank"
            >
              <FaFacebookF className="text-2xl text-own-secondary" />
            </a>
          </motion.li>
        </ul>
        <h2 className="text-2xl font-bold text-own-gray-white">
          Designed and Developed by
          <span className="text-own-secondary"> Md Sohag Hossain</span>
        </h2>
        <p className=" text-own-gray-white">
          Copyright © 2022, All Rights Reserved
        </p>
      </div>
    </div>
  );
};

export default Footer;
